<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <vue-plotly :white-mode="whiteMode" disable-responsive  v-if="!loading&&data" :data="data" :layout="layout" :options="{}" @click="handleClick"></vue-plotly>
        <data3-chart v-if="!loading&&data&&plotConfig"
                     :layout-overrides="plotConfig['layout-overrides']"
                     :on-only="false"
                     :x-axis="plotConfig['x-axis']"
                     :y-axis="plotConfig['y-axis']"
                     :color-axis="plotConfig['color-axis']"
                     :color-axis-scale="plotConfig['color-axis-scale']"
                     :color-axis-title="plotConfig['color-axis-title']"
                     disable-responsive
                     show-units
                     :data-payload="plotConfig['data-payload']"
                     :series-overrides="plotConfig['series-overrides']"
                     :date-range="dateRange"></data3-chart>
    </div>
</template>

<script>
    import {callAPI} from '@/helper'
    import LoadingProgressBar from './../LoadingProgressBar'
    import VuePlotly from "./../VuePlotly";
    import Data3Chart from "../Data3Chart";
    export default {
        props: {
            dateRange: {type: Object, default: null},
            equipmentName:{type: String, default: null},
            whiteMode:{type:Boolean, default: false}
        },
        components: {LoadingProgressBar,VuePlotly,Data3Chart},
        computed: {
            plotConfig(){
                if (this.selectedX&&this.selectedY){
                    return  {
                        'layout-overrides': {
                            title:this.equipmentName+" : "+this.selectedY+" VS "+this.selectedX,
                            colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                            xaxis: {
                                title: this.selectedX
                            },
                            yaxis: {
                                title: this.selectedY
                            },
                            zaxis: {
                                title: null
                            },
                            showlegend:false,
                            height:300,
                            hovermode:"closest",
                            margin:{
                                l: 300,
                                r: 50,
                                b: 50,
                                t: 50,
                                pad: 4
                            },
                            legend: {
                                orientation: 'h',
                                y: -0.3
                            },
                        },
                        "x-axis":this.selectedX,
                        "y-axis":null,
                        "color-axis":null,
                        "color-axis-scale":null,
                        "color-axis-title":null,
                        'data-payload': [{
                            'filters': {
                                equipment_name: this.equipmentName,
                                sensor_name: this.selectedX,
                                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            },
                            seriesOverrides:{
                                type:'scatter',
                                mode:'markers',
                                opacity:1,
                                xbins: {
                                    size: 1
                                },
                                ybins: {
                                    size: 1
                                }
                            },
                        },{
                            'filters': {
                                equipment_name: this.equipmentName,
                                sensor_name: this.selectedY,
                                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            },
                            seriesOverrides:{
                                type:'scatter',
                                mode:'markers',
                                opacity:1,
                                xbins: {
                                    size: 1
                                },
                                ybins: {
                                    size: 1
                                }
                            },
                        }],
                    }
                } else {
                    return null
                }
            }
        },
        name: 'CorrelationWidget',
        watch: {
            dateRange () {
                this.refresh()
            },
        },
        data: function () {
            return {
                loading: true,
                timeout:null,
                data:null,
                layout:null,
                selectedX:null,
                selectedY:null,
            }
        },
        mounted(){
            this.refresh()
        },
        methods: {
            handleClick(data){
                this.selectedX=null;
                this.selectedY=null;
                if(data&&data.points&&data.points[0]&&data.points[0].x&&data.points[0].y&&data.points[0].y!==data.points[0].x){
                    this.selectedX=data.points[0].x
                    this.selectedY=data.points[0].y
                    console.log(this.selectedX)
                    console.log(this.selectedY)
                }
            },
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.getData,500);
            },
            getData(){
                let me=this
                me.loading=true
                me.selectedX=null;
                me.selectedY=null;
                if(this.equipmentName&&this.equipmentName!==""){
                    callAPI('correlation/',{
                        date_range:[this.dateRange.start,this.dateRange.end],
                        filters: {
                            equipment_name: this.equipmentName,
                            facility_name: me.$store.state.pointsListStore.pointsList.facility_name
                        },
                        pipeline:[]
                    }).then(function(result) {
                        let sensors=Object.keys(result.data)
                        let values=[]
                        for (let key of sensors){
                            values.push(Object.values(result.data[key]))
                        }
                        let colorscaleValue = [
                            [-1, process.env.VUE_APP_THEME=='dark' ? "rgb(31, 119, 180)" : '#0000FF'],
                            [1, process.env.VUE_APP_THEME=='dark' ? "rgb(214, 39, 40)" : '#FF0000']
                        ]
                        sensors=sensors.map(x=>x.split(" - ")[1])
                        me.data = [{
                            x: sensors,
                            y: sensors,
                            z: values,
                            type: 'heatmap',
                            mode: 'markers',
                            colorscale: colorscaleValue,
                            zmin:-1,
                            zmax:1
                        }]
                        me.layout={
                            title: {text: me.equipmentName},
                            height:Math.max(400,25*sensors.length),
                            autosize: true,
                            hovermode: 'closest',
                            margin:{
                                l: 300,
                                r: 50,
                                b: 160,
                                t: 50,
                                pad: 4
                            },
                            yaxis: {
                                title: "",
                                categoryorder:"array",
                                categoryarray:sensors
                            },
                            xaxis: {
                                title: "",
                                categoryorder:"array",
                                categoryarray:sensors
                            },
                        }
                        me.loading=false
                    })
                }
            }
        },

    }

</script>

<style scoped>

</style>
